<template>
  <div id="StatusCell">
    <span v-if="currentStatus" :class="currentStatus.color">
      <i v-if="currentStatus.icon" class="status-icon" :class="currentStatus.icon" :style="currentStatus.iconStyle" />
      <span>{{ currentStatus.text }}</span>
    </span>
    <span v-else>{{ emptyText }}</span>
  </div>
</template>

<script>
export default {
  name: 'GjwStatusCell',
  props: {
    // 状态
    status: {
      type: [String, Number],
      default: null
    },
    config: {
      type: Array,
      default() {
        return []
      }
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusConfigs() {
      const defaultConfigs = [
        {
          status: 'PROCESSING',
          color: 'blue',
          icon: 'gjw-iconfont gjw-icon-icon_wait',
          iconStyle: 'font-size:16px;',
          text: '处理中'
        }, {
          status: 'PROCESSED_FAILED',
          color: 'red',
          icon: 'gjw-iconfont gjw-icon-icon_attention',
          iconStyle: 'font-size:16px;',
          text: '处理失败'
        }, {
          status: 'TOBE_RELEASED',
          color: 'yellow',
          icon: 'gjw-iconfont gjw-icon-icon_wait',
          iconStyle: 'font-size:16px;',
          text: '待发布'
        }, {
          status: 'RELEASED',
          color: 'green',
          icon: 'gjw-iconfont gjw-icon-done',
          iconStyle: 'font-size:16px;',
          text: '已发布'
        },
      ]
      return this.config && this.config.length ? this.config : defaultConfigs
    },
    currentStatus() {
      return this.statusConfigs.find((sc) => sc.status === this.status)
    }
  }
}
</script>

<style lang="less" scoped>
.status-icon{
  margin-right: 4px;
  font-size: 12px;
}
.blue{
  color: #1890FF;
}
.red{
  color: #E94D4D;
}
.yellow{
  color: #F8830B;
}
.green{
  color: #4FC403;
}
.grey{
  color: #909399;
}
</style>
